import { useEffect, useRef } from "react"
import { useLocation } from 'react-router-dom';

const AnalyticsHandler = () => {
  const location = useLocation()
  const scrollPctlevel = useRef(0); 

  const handleClick = (e) => {
    if (e.target.dataset["analytics"]) {
      const { action, label, category } = e.target.dataset
      window.TTB?.onAnalyticsEvent(action, label, category);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    window.addEventListener("scroll", scrollPage)

    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("scroll", scrollPage);
    }
  }, [])

  const getScrollPercent = ()=> {
    var h = document.documentElement, 
        b = document.body,
        st = 'scrollTop',
        sh = 'scrollHeight';
    //@ts-ignore
    return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
}

  const scrollPage = () => {
    const scrollPct = getScrollPercent();
    if (scrollPct > 25 && scrollPct < 50 && scrollPctlevel.current < 25) {
      scrollPctlevel.current = 25;
      window.TTB?.onAnalyticsEvent("page_depth", "scroll_25", "general");
    } 

    if (scrollPct > 50 && scrollPct < 75 && scrollPctlevel.current < 50) {
      scrollPctlevel.current = 50;
      console.log('50')
      window.TTB?.onAnalyticsEvent("page_depth", "scroll_50", "general");
    } 

    if (scrollPct > 50 && scrollPct > 75 && scrollPctlevel.current < 75) {
      scrollPctlevel.current = 75;
      window.TTB?.onAnalyticsEvent("page_depth", "scroll_75", "general");
    } 

    if (scrollPct === 100 && scrollPctlevel.current < 100) {
      scrollPctlevel.current = 100;
      window.TTB?.onAnalyticsEvent("page_depth", "scroll_100", "general");
    } 
  }

  useEffect(() => {
    window.TTB?.onAnalyticsView(`${window.location.pathname}${location.pathname}`);
  }, [location])

  return null;
};
export default AnalyticsHandler;
